import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { withApollo } from "@catchoftheday/graphql-utils";
import {
  Modal,
  Text,
  Button,
  Heading,
  Span,
  LoadingSpinner,
  Box,
} from "@catchoftheday/cg-components";
import {
  emitCancellationModalAction,
  emitCancellationModalImpression,
} from "@catchoftheday/analytics";
import {
  ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY,
  ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY,
} from "@common-vendors/consts";
import { useCustomerQuery } from "@common-vendors/generated/graphql";

export const OnePassCancellationModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { data, loading } = useCustomerQuery({ ssr: false });
  const { customer } = data || {};
  const { membership } = customer || {};

  const openModal = () => {
    emitCancellationModalImpression();
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window?.location?.search);
      if (
        queryParams?.[ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY] === "l" &&
        membership?.doubleSubscription
      ) {
        openModal();
      } else if (
        queryParams?.[ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY] === "1"
      ) {
        openModal();
      }
    }
  }, [data, membership?.doubleSubscription]);

  return (
    <Modal
      isOpen={isOpen}
      zIndex={101}
      maxWidth="600px"
      width="90%"
      borderRadius="16px"
      closeButtonProps={{
        bg: "onePass.primaryDarker",
        width: "36px",
        height: "36px",
      }}
      closeIconProps={{ width: "16px", height: "16px" }}
      onRequestClose={() => {
        emitCancellationModalAction("close");
        closeModal();
      }}
      contentProps={{
        height: "auto",
      }}
      enableDefaultResponsiveStyles={false}
    >
      {loading && (
        <LoadingSpinner
          containerProps={{ "aria-label": "loading spinner", zIndex: 1 }}
          hasOverlay
          ringBg="ui.borderColor"
        />
      )}
      <Box visibility={loading ? "hidden" : "visible"}>
        <Heading.h3
          fontFamily="onePass"
          color="onePass.textPrimary"
          fontWeight="bold"
          mt="0px"
          mb={{
            xs: "30px",
            md: "24px",
          }}
        >
          Important: Your OnePass Subscription
        </Heading.h3>
        <Text
          fontFamily="onePass"
          color="onePass.textPrimary"
          fontWeight="medium"
          fontSize="base"
          mt="0px"
          mb={{
            xs: "48px",
            md: "32px",
          }}
        >
          <Span display="block" fontWeight="inherit">
            Looks like you had two active subscriptions with OnePass.
          </Span>
          <Span display="block" my="20px" fontWeight="inherit">
            We&apos;ve fixed this to ensure you will be billed correctly, so you
            can continue enjoying your benefits.
          </Span>
          <Span display="block" fontWeight="inherit">
            If you have any further queries, please reach out to our customer
            service team 1300 551 996.
          </Span>
        </Text>
        <Button
          variant="onePassPrimary"
          width={{ xs: "100%", md: "50%" }}
          onClick={() => {
            emitCancellationModalAction("confirm");
            closeModal();
          }}
        >
          Got it
        </Button>
      </Box>
    </Modal>
  );
};

export const OnePassCancellationModalWithApollo = withApollo({
  uri: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
})(OnePassCancellationModal);
